import '.a{display:flex;}.ssr-plugin'
import '.j{gap:16px;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import '.f{width:100%;}.ssr-plugin'
import '.k{padding-bottom:16px;}.ssr-plugin'
import '.l{display:grid;}.ssr-plugin'
import '.m{padding-bottom:48px;}.ssr-plugin'
import '.n{align-items:stretch;}.ssr-plugin'
import { FC, useEffect } from 'react'
import { Layout } from './Layout'
import { styled } from 'inlines'
import { Navigation } from '../components/Navigation'
import { Text } from '../components/Text'
import { useAppCtx } from '../providers/useAppCtx'
import { ExpandableText } from '../components/ExpandableText'
import { ContestantCard } from '../components/ContestantCard'
import { useIsMobile } from '../hooks/useIsMobile'
import { CartBar } from '../components/CartBar'
import { useContentQuery } from '../hooks/useContentQuery'
import { useQuery } from '@based/sdk'
// @ts-ignore
import fallbackImage from '../assets/img/Square-Heart.png'
import { useTranslations } from '../hooks/useTranslations'

export type ContestantsProps = {
  'aria-label'?: {
    nav: string
    footer: string
  }
}

export const Contestants: FC<ContestantsProps> = ({
  'aria-label': ariaLabelProp = {
    nav: 'Main navigation',
    footer: 'Footer navigation',
  },
}) => {
  const { languages, votes, setVotes, votesCount } = useAppCtx()
  const { data: sequence = {} } = useContentQuery('sequence')
  // @ts-ignore
  const edition = window?.DATA?.edition
  const { data: config = {} } = useQuery(
    edition !== undefined ? 'edition-config' : '',
    {
      editionId: edition,
    },
  )

  const { data: dictionary = {} } = useTranslations('voting')

  const isMobile = useIsMobile()

  const toggleContent = [
    dictionary?.expand_rules_button,
    dictionary?.collapse_rules_button,
  ]
  const contestants = sequence?.round.contestants || []
  const { price, currency, maxVotes } = config
  const remainingVotes = maxVotes - votesCount

  return (
    <Layout
      style={{
        justifyContent: 'start',
        gap: 48,
        ...(isMobile
          ? {
              padding: 24,
            }
          : {
              padding: '48px 24px',
              alignSelf: 'center',
            }),
      }}
    >
      <Layout.Navbar>
        <Navigation
          as="nav"
          aria-label={ariaLabelProp.nav}
          isCartVisible
          isExpandable
          cartItems={votesCount}
          languages={languages}
        />
      </Layout.Navbar>

      <Layout.Top>
        <div className="a j i f"
        >
          <Text color={'gradient'} variant="title" isMultiline>
            {dictionary?.voting_prompt}
          </Text>
          <ExpandableText
            visibleContent={dictionary?.short_voting_rules}
            hiddenContent={dictionary?.short_payment_rules}
            label={toggleContent}
          />
        </div>
      </Layout.Top>

      <Layout.Middle>
        <div className="f k">
          <div className="f l m n"
            style={{
              gridTemplateColumns: isMobile
                ? 'repeat(auto-fit, minmax(136px, 1fr))'
                : 'repeat(auto-fit, minmax(174px, 1fr))',
              // gridAutoFlow: 'dense',
              gap: isMobile ? 16 : 32,}}
          >
            {contestants
              .filter((contestant) => !contestant?.$disqualified)
              ?.sort((a, b) => Number(a.$ddi) - Number(b.$ddi))
              ?.map((contestant, index) => {
                const currentVotes = votes?.[contestant.$ddi] || 0
                const maxForThis = currentVotes + remainingVotes

                return (
                  <ContestantCard
                    key={contestant.id + '-' + contestant.name + '-' + index}
                    isInverted={currentVotes === 0}
                    label={contestant.name}
                    description={contestant.song}
                    votePrice={price}
                    currency={currency}
                    image={contestant.image?.src || fallbackImage}
                    votes={currentVotes}
                    isFocused={currentVotes > 0}
                    maxVotes={maxForThis}
                    ddi={contestant.$ddi}
                    on={{
                      change: (newVotesForThis) => {
                        const parseVotes = (prev) => {
                          if (newVotesForThis === 0 && prev) {
                            const { [contestant.$ddi]: _, ...rest } = prev
                            return rest
                          }
                          return {
                            ...prev,
                            [contestant.$ddi]: newVotesForThis,
                          }
                        }
                        setVotes(parseVotes(votes))
                      },
                    }}
                    style={{ maxWidth: 176 }}
                  />
                )
              })}
          </div>

          <Text color="gradient" variant="title" isMultiline>
            {dictionary?.voting_banner}
          </Text>
        </div>
      </Layout.Middle>

      <Layout.Footer>
        <Navigation
          as="footer"
          aria-label={ariaLabelProp.footer}
          languages={languages}
          style={{ marginBottom: votesCount > 0 ? 96 : 0 }}
        />

        {votesCount > 0 && <CartBar />}
      </Layout.Footer>
    </Layout>
  )
}
